const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {}

export const getLoginUserData = ()=>{
    return user
}

export const getLoginUserRoleId = ()=>{
    return user?.roleId
}

export const getLoginUserName = ()=>{
    return user?.fullName
}

export const getLoginUserId = ()=>{
    return user?.userId
}